module.exports = __webpack_public_path__ + "img/Play.33a005c8.png";